import React from 'react';
import PropTypes from 'prop-types';

import './ListText.css';

const classNames = ({
  className,
  success,
  pending,
  inactive,
  fail,
  textColor,
  errorBox,
}) => {
  const names = ['ListText'];

  if (className) {
    names.push(className);
  }
  if (textColor) {
    names.push('textColor');
  }
  if (success) {
    names.push('success');
  }
  if (pending) {
    names.push('pending');
  }
  if (inactive) {
    names.push('inactive');
  }
  if (fail) {
    names.push('fail');
  }
  if (errorBox) {
    names.push('errorBox');
  }
  return names.join(' ');
}

const ListText = ({
  children,
  className,
  textColor,
  success,
  pending,
  inactive,
  fail,
  errorBox,
}) => (
    <li
      className={classNames({
        className,
        textColor,
        success,
        pending,
        inactive,
        fail,
        errorBox,
      })}>
      { children }
    </li>
);

ListText.propTypes = {
  className: PropTypes.string,
  textColor: PropTypes.bool,
  children: PropTypes.node,
  success: PropTypes.bool,
  pending: PropTypes.bool,
  inactive: PropTypes.bool,
  fail: PropTypes.bool,
  errorBox: PropTypes.bool,
};

ListText.defaultProps = {
  className: null,
  children: null,
  textColor: false,
  success: false,
  pending: false,
  inactive: false,
  fail: false,
  errorBox: false,
};

export default ListText;



// WEBPACK FOOTER //
// ./src/components/ListText.jsx